/**
 * Các đối tượng báo hàng ĐÃ BIẾT (có nhãn tiếng Việt sẵn). KHÔNG phải danh sách đóng:
 * đối tượng do MP bắn sang trong searchStr/menu_audience nên tuỳ trường có thể có
 * giá trị khác — filter "Phân loại" sinh options động từ data, không hardcode.
 */
export enum FoodTraceabilityAudienceEnum {
  student = 'student',
  teacher = 'teacher',
}

export enum FoodTraceabilityStateEnum {
  propose = 'propose',
  confirm = 'confirm',
  complete = 'complete',
}

export interface FoodTraceabilityFilterModel {
  /** `YYYY-MM` — khung thực đơn của năm học, KHÔNG phải số tháng của năm dương lịch. */
  month?: string;
  week?: number | '';
  /** Ngày ăn dạng `YYYY-MM-DD` ('' = tất cả) — khung trải hai tháng nên ngày phải mang cả tháng. */
  day?: string | '';
  /** Đối tượng báo hàng ('' = tất cả). Chuỗi tự do — xem FoodTraceabilityAudienceEnum. */
  audience?: string;
  state?: FoodTraceabilityStateEnum;
}

export interface FoodTraceabilityItem {
  menu_date?: string;
  dish_display_name?: string;
  ingredient_name?: string;
  /** Tên hàng hóa (kho) do API bắn sang — dùng cho cột "Tên hàng hóa". */
  selected_warehouse_food_name?: string;
  standard_headcount?: number;
  standard_quantity?: number;
  quantity_gram?: number;
  unit?: string;
  supplier_name?: string;
  supplier_operation_code?: string;
}

export interface FoodTraceabilityModel {
  searchStr: string;
  parentId?: string;
  type?: string;
  structuredData: {
    data: {
      info?: {
        date_to?: string;
        date_from?: string;
        month_key?: string;
        week_number?: number;
        customer_operation_code?: string;
      };
      items: FoodTraceabilityItem[];
    };
    metadata?: {
      isUsed?: boolean;
    };
  };
  metadata?: {
    v20241121?: {
      year?: number;
      month?: number;
      week?: number | null;
      day?: number | null;
      state?: string;
      menu_audience?: string;
    };
  };
  deletedAt?: string | null;
  updatedAt?: string;
}

export interface FoodTraceabilityRow extends FoodTraceabilityItem {
  id: string;
  stt: number;
}
